module.exports = __webpack_public_path__ + "img/uakin.59ec4bbd.png";